<template>
  <div class="anim-course">
    <anim-course
      :visible="TopnavMsg.isShowAnimCourseDialog"
    ></anim-course>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import animCourse from './emodal/animCourse/animCourseDialog.vue'

export default {
  components: {
    animCourse
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'TopnavMsg',
    ])
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.anim-course {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 25;
}
</style>



// WEBPACK FOOTER //
// src/components/AnimCourse.vue